import { forEach, filter, includes, reduce, map, } from 'lodash';
import { siblingIdFromName, determineSiblingUsed } from "@/utils/helper.functions";
var FreeChoiceModel = /** @class */ (function () {
    function FreeChoiceModel(data) {
        this.used = data.used || 0;
        this.count = data.count;
        this.options = data.options || data.included_options;
    }
    FreeChoiceModel.prototype.filterOptions = function (options) {
        var setOptions = this.options;
        var optionsInSet = filter(options, function (option) {
            var hasOption = includes(setOptions, option.id);
            return hasOption;
        });
        return optionsInSet;
    };
    FreeChoiceModel.prototype.getCountsForOptions = function (options) {
        var filteredOptions = this.filterOptions(options);
        var counts = {};
        forEach(filteredOptions, function (option) {
            counts[option.id] = option.countNonIncludedChoices();
        });
        return counts;
    };
    return FreeChoiceModel;
}());
var FreeChoiceSetModel = /** @class */ (function () {
    function FreeChoiceSetModel(data) {
        var _this = this;
        this.choiceSets = [];
        if (data) {
            var choiceSets = data.choiceSets;
            if (!choiceSets) {
                choiceSets = data;
            }
            forEach(choiceSets, function (freeChoiceRaw) {
                var freeChoice = new FreeChoiceModel(freeChoiceRaw);
                _this.choiceSets.push(freeChoice);
            });
        }
        this.__mc = "FreeChoiceSetModel";
    }
    // TODO handling premium choices
    FreeChoiceSetModel.prototype.freeChoicesRemaining = function () {
        var choiceSets = this.choiceSets;
        var remainingTotal = reduce(choiceSets, function (accumulator, choiceSet) {
            return accumulator + choiceSet.count;
        }, 0);
        forEach(choiceSets, function (choiceSet) {
            remainingTotal -= choiceSet.used;
        });
        return remainingTotal;
    };
    FreeChoiceSetModel.prototype.assignFreeChoices = function (totals) {
        var choiceSets = this.choiceSets;
        var siblingUsed = determineSiblingUsed(totals);
        forEach(choiceSets, function (choiceSet) {
            choiceSet.used = 0;
            forEach(totals, function (options, sibling) {
                var siblingId = siblingIdFromName(sibling);
                var isUsedSibling = (siblingId === siblingUsed || siblingId === '0');
                var optionKeys = map(options, function (option, key) {
                    return {
                        id: key,
                        choices: option,
                    };
                });
                var filteredOptions = choiceSet.filterOptions(optionKeys);
                forEach(filteredOptions, function (option) {
                    var choices = option.choices;
                    if (choices) {
                        forEach(choices, function (choice) {
                            choice.free = 0;
                        });
                        forEach(choices, function (choice) {
                            if (choice.included) {
                                return;
                            }
                            if (isUsedSibling) {
                                choiceSet.used++;
                            }
                            if (choiceSet.used <= choiceSet.count) {
                                choice.free = 1;
                            }
                            if (!isUsedSibling) {
                                choice.free = 1;
                            }
                        });
                    }
                });
            });
        });
        return totals;
    };
    return FreeChoiceSetModel;
}());
export default FreeChoiceSetModel;
export { FreeChoiceModel };



//////////////////
// WEBPACK FOOTER
// ./src/models/FreeChoiceSetModel.ts
// module id = lOkT
// module chunks = 18